<template>
<div>
  <b-row>
    <b-col md="4">
      <div class="select">
        <label>Viloyat/shahar</label>
      <b-form-select
          style="margin-top: 5px"
          v-model="selected"
          :options="options"
          class="form-select"
          aria-label="Default select example"></b-form-select>
        <label>Tuman</label>
      <b-form-select
          style="margin-top: 5px"
          v-model="selected"
          :options="options"
          class="form-select"
          aria-label="Default select example"></b-form-select>
        <br>
        <b-form-input
            id="input-default"
            style="margin-top: 5px"
            placeholder="Maktabning to'liq nomi"></b-form-input>
        <br>
        <b-form-input
            id="input-default"
            style="margin-top: 5px"
            placeholder="Qisqa nomi"></b-form-input>
        <label class="mt-2">Qaysi vazirlik (qo'mitasi) tasarrufida</label>
        <b-form-select
            style="margin-top: 5px"
            v-model="selected"
            :options="options"
            class="form-select"
            aria-label="Default select example"></b-form-select>
        <label class="mt-2">Ixtisoslik yo'nalishi</label>
        <b-form-select
            style="margin-top: 5px"
            v-model="selected"
            :options="options"
            class="form-select"
            aria-label="Default select example"></b-form-select>
        <SpinButtons />
      </div>
    </b-col>
    <b-col md="8">
    <Map />
    </b-col>
  </b-row>
  <SecondRow />
  <div  class="btn" >
    <b-button
        size="md"
        style="margin-left: 400px; margin-top: 30px"
        variant="outline-primary">{{$t('message.Cancel')}}</b-button>
    <b-button
        size="md"
        style="margin-left: 20px; margin-top: 30px"
        variant="primary">{{$t('message.Add')}}</b-button>
  </div>
</div>
</template>

<script>
import SpinButtons from "./SpinButtons";
import SecondRow from "./SecondRow";
import Map from "./Map";
export default {
  name: "FirstRow",
  components: {Map, SecondRow, SpinButtons},
  data(){
    return{
      options: [
        { value: null, text: 'Please select an option' },
        { value: 'a', text: 'This is First option' },
        { value: 'b', text: 'Selected Option' },
        { value: { C: '3PO' }, text: 'This is an option with object value' },
      ],
    }
  }
}
</script>

<style scoped>
.select{
  margin-left: 70px;
}

</style>
